import { createSlice } from '@reduxjs/toolkit';
import { ACTIONS_ENTITLEMENT_HISTORY } from '../../../constants/actionCreator';
import { initialState } from '../../../data/entitlement/entitlementHistory/initialState.entitlementHistory.data';
import { handlePending, handleRejection } from '../../../constants';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import {
  updateEntitlementHistoryActiveInactive as updateEntitlementHistoryActiveInactiveAPI,
  getEntitlementStatus as getEntitlementStatusAPI,
  getSpecificEntitlementData as getSpecificEntitlementDataAPI,
  getEntitlementHistoryData as getEntitlementHistoryDataAPI,
  getEntHisDataForValidation as getEntHisDataForValidationAPI,
  createEntitlementHistoryNote as createEntitlementHistoryNoteAPI,
  getEntitlementHistoryStatus as getEntitlementHistoryStatusAPI,
  getEntitlementHistoryDetails as getEntitlementHistoryDetailsAPI,
  createEntitlementHistory as createEntitlementHistoryAPI,
  getEntitlementServiceLevel as getEntitlementServiceLevelAPI,
  fetchEntitlementNotes as fetchEntitlementNotesAPI,
  createEntitlementNote as createEntitlementNoteAPI,
  getEntitlementProductHistory as getEntitlementProductHistoryAPI,
  transferEntitlement as transferEntitlementAPI,
  entitlementTransferData as entitlementTransferDataAPI,
  entitlementWarrantyHistory as entitlementWarrantyHistoryDataAPI,
  entitlementSerialNumberHistory as entitlementSerialNumberHistoryDataAPI,
  getEntitlementSpecificWarrantyHistoryDetails as getEntitlementSpecificWarrantyHistoryDetailsDataAPI,
  checkWarrantyHistoryUpsert as checkWarrantyHistoryUpsertDataAPI,
  validateWarrantyHistoryStartDate as validateWarrantyHistoryStartDateDataAPI,
  createNewEntitlementWarranty as createNewEntitlementWarrantyAPI,
  updateNewEntitlementWarranty as updateNewEntitlementWarrantyAPI,
  deleteNewEntitlementWarranty as deleteNewEntitlementWarrantyAPI,
  createUpdateNewEntitlementHistory as createUpdateNewEntitlementHistoryAPI,
  saveAndCloseEntitlementTransfer as saveAndCloseEntitlementTransferAPI,
  saveAndCloseEntitlementSite as saveAndCloseEntitlementSiteAPI,
  saveAndCloseEntitlementSiteActivity as saveAndCloseEntitlementSiteActivityAPI,
} from '../../../apis/entitlementHistoryAPI';

export const updateEntitlementHistoryActiveDeactive = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.UPDATE_ENTITLEMENT_HISTORY_ACTIVE_INACTIVE,
  updateEntitlementHistoryActiveInactiveAPI
);

export const getEntitlementStatus = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.GET_STATUS_ENTITLEMENT,
  getEntitlementStatusAPI
);

export const getSpecificEntitlementData = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.GET_DATA_ENTITLEMENT,
  getSpecificEntitlementDataAPI
);

export const getEntitlementHistoryData = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.GET_ENTITLEMENT_HISTORY,
  getEntitlementHistoryDataAPI
);

export const getEntHisDataForValidation = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.GET_ENTITLEMENT_HISTORY_VALIDATION,
  getEntHisDataForValidationAPI
);

export const createEntitlementHistoryNote = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.CREATE_ENTITLEMENT_HISTORY_NOTE,
  createEntitlementHistoryNoteAPI
);

export const createEntitlementHistory = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.CREATE_ENTITLEMENT_HISTORY,
  createEntitlementHistoryAPI
);

export const getEntitlementHistoryStatus = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.GET_ENTITLEMENT_HISTORY_STATUS,
  getEntitlementHistoryStatusAPI
);

export const getEntitlementServiceLevel = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.GET_ENTITLEMENT_SERVICE_LEVEL,
  getEntitlementServiceLevelAPI
);

export const getEntitlementHistoryDetails = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.GET_ENTITLEMENT_HISTORY_DETAILS,
  getEntitlementHistoryDetailsAPI
);

export const getEntitlementProductHistory = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.GET_ENTITLEMENT_PRODUCT_HISTORY,
  getEntitlementProductHistoryAPI
);

export const fetchEntitlementNotes = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.GET_ENTITLEMENT_NOTES,
  fetchEntitlementNotesAPI
);

export const createEntitlementNote = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.CREATE_ENTITLEMENT_NOTE,
  createEntitlementNoteAPI
);

export const transferEntitlement = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.TRANSFER_ENTITLEMENT,
  transferEntitlementAPI
);

export const entitlementTransferData = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.TRANSFER_ENTITLEMENT_DATA,
  entitlementTransferDataAPI
);

export const entitlementWarrantyData = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.ENTITLEMENT_WARRANTY_DATA,
  entitlementWarrantyHistoryDataAPI
);

export const entitlementSerialNumberHistoryData = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.ENTITLEMENT_SERIAL_NUMBER_HISTORY_DATA,
  entitlementSerialNumberHistoryDataAPI
);

export const specificWarrantyHistoryDetailsData = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.SPECIFIC_WARRANTY_HISTORY_DETAIL_DATA,
  getEntitlementSpecificWarrantyHistoryDetailsDataAPI
);

export const checkWarrantyHistoryUpsert = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.CHECK_WARRANTY_HISTORY_UPSERT_DATA,
  checkWarrantyHistoryUpsertDataAPI
);

export const validateWarrantyHistoryStartDate = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.VALIDATE_WARRANTY_HISTORY_START_DATE,
  validateWarrantyHistoryStartDateDataAPI
);

export const createNewEntitlementWarranty = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.CREATE_NEW_ENTITLEMENT_WARRANTY,
  createNewEntitlementWarrantyAPI
);

export const updateNewEntitlementWarranty = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.UPDATE_NEW_ENTITLEMENT_WARRANTY,
  updateNewEntitlementWarrantyAPI
);

export const deleteNewEntitlementWarranty = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.DELETE_NEW_ENTITLEMENT_WARRANTY,
  deleteNewEntitlementWarrantyAPI
);

export const createUpdateNewEntitlementHistory = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.CREATE_UPDATE_NEW_ENTITLEMENT_HISTORY,
  createUpdateNewEntitlementHistoryAPI
);

export const saveAndCloseEntitlementTransfer = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.SAVE_AND_CLOSE_ENTITLEMENT_TRANSFER,
  saveAndCloseEntitlementTransferAPI
);

export const saveAndCloseEntitlementSite = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.SAVE_AND_CLOSE_ENTITLEMENT_SITE,
  saveAndCloseEntitlementSiteAPI
);

export const saveAndCloseEntitlementSiteActivity = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_HISTORY.SAVE_AND_CLOSE_ENTITLEMENT_SITE_ACTIVITY,
  saveAndCloseEntitlementSiteActivityAPI
);

const entitlementHistorySlice = createSlice({
  name: 'entitlementHistory',
  initialState,
  reducers: {
    setDate: (state, action) => {
      state.actionDate = action?.payload;
    },
    setErrorMessages: (state, action) => {
      state.popupErrorMessage = action?.payload ? action?.payload : '';
    },
    editModalOpen: (state, action) => {
      state.isEntitlementHistoryEditModalOpen = action?.payload;
    },
    editModalClose: (state, action) => {
      state.isEntitlementHistoryEditModalOpen = action?.payload;
    },
    addModalOpen: (state, action) => {
      state.isEntitlementHistoryAddModalOpen = action?.payload;
    },
    addModalClose: (state, action) => {
      state.isEntitlementHistoryAddModalOpen = action?.payload;
    },
    setCurrencyData: (state, action) => {
      state.currencyId = action?.payload;
    },
    setServiceLevelData: (state, action) => {
      state.serviceLevelId = action?.payload;
    },
    setAnnualFeeData: (state, action) => {
      if (action?.payload < 0) state.annualFee = 0;
      else state.annualFee = action?.payload ? action?.payload : 0;
    },
    setStatusData: (state, action) => {
      state.statusId = action?.payload;
    },
    setCommentData: (state, action) => {
      state.comment = action?.payload;
    },
    addNewNote: (state, action) => {
      state.isAddNewNote = action?.payload;
    },
    setERPProductDisplay: (state, action) => {
      state.erpDisplayProduct = action?.payload;
    },
    isWarrantyAddModalOpen: (state, action) => {
      state.showAddWarrantyModal = action?.payload;
      state.warrantyFormData.comment = initialState.warrantyFormData.comment;
      if (state.isEditMode === false) {
        state.warrantyFormData.warrantyStartDate = new Date();
      }
    },
    isWarrantyEditModalOpen: (state, action) => {
      state.showEditWarrantyModal = action?.payload;
    },
    setErrorMessagePopup: (state, action) => {
      state.errorMessagePopup = action?.payload;
    },
    errorMessageStateToInitialState: (state, action) => {
      state.isCheckedWarrantyUpsert = action?.payload;
    },
    warrantyHistorySpecificData: (state, action) => {
      state.warrantyHistorySpecificDataStartDate = action?.payload;
    },
    addWarrantyButtonClickState: (state, action) => {
      state.addWarrantyButtonClick = action?.payload;
    },
    addWarrantyStartDate: (state, action) => {
      state.warrantyFormData.warrantyStartDate = action?.payload;
    },
    addWarrantyDuration: (state, action) => {
      state.warrantyFormData.warrantyDuration = action?.payload;
    },
    addWarrantyFeeDefferal: (state, action) => {
      state.warrantyFormData.warrantyFeeDefferal = action?.payload;
    },
    warrantyAddComment: (state, action) => {
      state.warrantyFormData.comment = action?.payload;
    },
    settingErrorMessage: (state, action) => {
      state.startDateValidatedErrorMessage = action?.payload;
    },
    settingIsEditMode: (state, action) => {
      state.isEditMode = action?.payload;
    },
    settingHistoryAddEdit: (state, action) => {
      state.entitlementHistoryDataAddEdit = action?.payload
        ? action?.payload
        : [];
    },
    updateErrorMessagePopUpState: (state) => {
      state.setingAddErrorMessage = null;
    },
    settingTransferGridDataRow: (state, action) => {
      state.transferGridRowData = action?.payload ? action?.payload : [];
    },
    settingCheckedWarrantyUpsert: (state) => {
      state.isCheckedWarrantyUpsert = initialState.isCheckedWarrantyUpsert;
      state.isStartDateValidated = initialState.isStartDateValidated;
    },
    settingWarrantySpecificDataToNull: (state) => {
      state.getEntitlementSpecificWarrantyHistoryDetailsData =
        initialState.getEntitlementSpecificWarrantyHistoryDetailsData;
    },
    settingRedirectionSiteActivityFlag: (state, action) => {
      state.redirectionSiteActivityFlag = action?.payload;
    },
    resetapiSuccessAction: (state) => {
      state.apiSuccess = initialState.apiSuccess;
      state.apiSuccessMessage = initialState.apiSuccessMessage;
      state.apiErrorMessage = initialState.apiErrorMessage;
      state.popupErrorMessage = initialState.popupErrorMessage;
    },
    resetingAddWarrantyForm: (state) => {
      state.warrantyFormData.warrantyStartDate = '';
      state.warrantyFormData.warrantyDuration = '';
      state.warrantyFormData.warrantyFeeDefferal = 0;
      state.warrantyFormData.comment = '';
      state.newWarrantyLoader = false;
      state.apiWarrentySuccessResponse = {
        ...initialState.apiWarrentySuccessResponse,
        create: false,
        update: false,
      };
    },
    resettingTransferDataFound: (state) => {
      state.entitlementTransferDataData = [];
      state.entitlementTransferDataDataTotalCount = 0;
      state.entitlementTransferDataFound = false;
      state.transferEntitlementData = [];
      state.isPriceClassFound = null;
      state.transferGridRowData = [];
      state.apiHistoryTransferLoader = false;
      state.entitlementTrasferGridDisplay = false;
      state.trasferResult = [];
    },
    handleSiteForTransfer: (state, action) => {
      state.currentSiteForTrnasfer = action?.payload || null;
    },
    handleSiteForShowData: (state, action) => {
      state.selectedSiteForShowData = action?.payload || null;
    },
    handleResetApiCall: (state) => {
      state.apiSuccessResponse = initialState.apiSuccessResponse;
      state.apiHistorySuccessResponse = initialState.apiHistorySuccessResponse;
    },
    handleNotRefreshEntOnTransfer: (state, action) => {
      state.notRefreshEntOnTransfer = action?.payload ? action?.payload : false;
    },
    resetIsSiteActivityFailed: (state, action) => {
      state.isSiteActivityFailed =
        action?.payload || initialState.isSiteActivityFailed;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEntitlementStatus.pending, handlePending)
      .addCase(getEntitlementStatus.fulfilled, (state, action) => {
        state.apiStatusData = action?.payload ? action.payload : [];
      })
      .addCase(getEntitlementStatus.rejected, handleRejection)

      .addCase(getSpecificEntitlementData.pending, handlePending)
      .addCase(getSpecificEntitlementData.fulfilled, (state, action) => {
        state.entitlementData = action?.payload ? action.payload : [];
      })
      .addCase(getSpecificEntitlementData.rejected, handleRejection)

      .addCase(getEntitlementHistoryData.pending, (state) => {
        state.entitlementHistoryLoading = true;
        state.entitlementHistoryTotalCount = 0;
        state.entitlementHistoryData = null;
      })
      .addCase(getEntitlementHistoryData.fulfilled, (state, action) => {
        state.entitlementHistoryLoading = false;
        state.entitlementHistoryTotalCount = action?.payload?.totalRecords;
        state.entitlementHistoryData = action?.payload
          ? action?.payload?.entitlementHistory?.map((item, index) => ({
              id: index,
              ...item,
            }))
          : [];
        state.entitlementHistoryDataAddEdit =
          action?.payload?.entitlementHistory?.map((item) => ({
            entitlementSiteHistoryDto: {
              entitlementId: item.entitlementId,
              siteStartDate: item.siteStartDate,
              effectiveDate: item.effectiveDate,
              entitlementStatusId: item.entitlementStatusId,
              currencyId: item.currencyId,
              annualfee: item.annualfee,
              serviceLevelId: item.serviceLevelId,
              comment: item.comment,
              lastModifiedTimestamp: item.lastModifiedTimestamp,
              firstModifiedTimestamp: item.firstModifiedTimestamp,
              lastModifiedUserId: item.lastModifiedUserId,
              firstModifiedUserId: item.firstModifiedUserId,
            },
            noteComment: '',
            isInserted: false,
            isUpdated: false,
          }));
      })
      .addCase(getEntitlementHistoryData.rejected, (state) => {
        state.entitlementHistoryLoading = false;
        state.entitlementHistoryTotalCount = 0;
        state.entitlementHistoryData = null;
      })

      .addCase(getEntHisDataForValidation.pending, (state) => {
        state.entHisDataForValidation = null;
        state.entHisDataForVal_Loading = true;
      })
      .addCase(getEntHisDataForValidation.fulfilled, (state, action) => {
        state.entHisDataForVal_Loading = false;
        state.entHisDataForValidation = action?.payload
          ? action?.payload?.entitlementHistory
          : [];
      })
      .addCase(getEntHisDataForValidation.rejected, (state) => {
        state.entHisDataForVal_Loading = false;
        state.entHisDataForValidation = null;
      })

      .addCase(updateEntitlementHistoryActiveDeactive.pending, (state) => {
        state.loadingActiveDeactive = true;
        state.isPriceClassFound = null;
        state.popupErrorMessage = '';
        state.apiSuccess = null;
      })
      .addCase(
        updateEntitlementHistoryActiveDeactive.fulfilled,
        (state, action) => {
          if (action?.payload?.status === false) {
            state.apiSuccess = 'error';
            state.isPriceClassFound = 'popalert';
            state.popupErrorMessage = action?.payload?.message;
          }

          if (action?.payload?.status === true) {
            state.popupErrorMessage = '';
            state.isPriceClassFound = 'nonpopalert';
            state.apiSuccess = 'success';
            state.apiSuccessMessage = action?.payload?.message;
          }

          state.loadingActiveDeactive = false;
          state.activeInactiveDataStatus = action?.payload
            ? action?.payload
            : [];
          state.activeInactiveData = action?.payload ? action?.payload : [];
          state.apiSuccessResponse = {
            ...initialState.apiSuccessResponse,
            update: true,
          };
        }
      )
      .addCase(
        updateEntitlementHistoryActiveDeactive.rejected,
        (state, action) => {
          state.loadingActiveDeactive = false;
          state.isPriceClassFound = 'popalert';
          //state.popupErrorMessage = ENTITLEMENT_DATA.priceClassError;
          state.popupErrorMessage = '';
          if (action?.payload?.status === true) {
            state.apiSuccess = 'success';
            state.apiErrorMessage = action?.payload?.message;
          }
        }
      )

      .addCase(getEntitlementHistoryStatus.pending, handlePending)
      .addCase(getEntitlementHistoryStatus.fulfilled, (state, action) => {
        state.entitlementHistoryStatus = action?.payload
          ? action.payload?.filter((item) => item?.name !== 'Pending')
          : [];
      })
      .addCase(getEntitlementHistoryStatus.rejected, handleRejection)

      .addCase(getEntitlementServiceLevel.pending, handlePending)
      .addCase(getEntitlementServiceLevel.fulfilled, (state, action) => {
        state.entitlementServiceLevel = action?.payload ? action.payload : [];
      })
      .addCase(getEntitlementServiceLevel.rejected, handleRejection)

      .addCase(getEntitlementHistoryDetails.pending, (state) => {
        state.entitlementHistoryDetailsFound = false;
      })
      .addCase(getEntitlementHistoryDetails.fulfilled, (state, action) => {
        state.entitlementHistoryDetails = action?.payload ? action.payload : [];
        state.entitlementHistoryDetailsFound = true;
      })
      .addCase(getEntitlementHistoryDetails.rejected, handleRejection)

      .addCase(createEntitlementHistoryNote.pending, handlePending)
      .addCase(createEntitlementHistoryNote.fulfilled, (state, action) => {
        state.entitlementHistoryDetails = action?.payload ? action.payload : [];
      })
      .addCase(createEntitlementHistoryNote.rejected, handleRejection)

      .addCase(createEntitlementHistory.pending, (state) => {
        state.setingAddErrorMessage = null;
      })
      .addCase(createEntitlementHistory.fulfilled, (state) => {
        state.setingAddErrorMessage = null;
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          create: true,
        };
      })
      .addCase(createEntitlementHistory.rejected, (state, action) => {
        state.popupErrorMessage = action?.payload;
        state.setingAddErrorMessage = true;
      })

      .addCase(fetchEntitlementNotes.pending, (state) => {
        state.loadingNotes = true;
        state.entitlementNotesData = [];
        state.isNotesFound = null;
      })
      .addCase(fetchEntitlementNotes.fulfilled, (state, action) => {
        state.entitlementNotesData = action?.payload ? action.payload : [];
        state.entitlementNoteTotalCount = action?.payload
          ? action?.payload[0]?.totalRecords
          : 0;
        state.loadingNotes = false;
        state.isNotesFound = true;
      })
      .addCase(fetchEntitlementNotes.rejected, (state) => {
        state.entitlementNotesData = [];
        state.isNotesFound = true;
        state.entitlementNoteTotalCount = 0;
        state.loadingNotes = false;
      })

      .addCase(createEntitlementNote.pending, (state) => {
        state.noteCreateLocading = true;
      })
      .addCase(createEntitlementNote.fulfilled, (state) => {
        state.noteCreateLocading = false;
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          create: true,
        };
      })
      .addCase(createEntitlementNote.rejected, (state) => {
        state.noteCreateLocading = false;
      })

      .addCase(getEntitlementProductHistory.pending, handlePending)
      .addCase(getEntitlementProductHistory.fulfilled, (state, action) => {
        state.entitlementProductHistoryData = action?.payload
          ? action.payload
          : [];
      })
      .addCase(getEntitlementProductHistory.rejected, handleRejection)

      .addCase(transferEntitlement.pending, (state) => {
        state.loadingTransfer = true;
      })
      .addCase(transferEntitlement.fulfilled, (state, action) => {
        state.loadingTransfer = false;
        state.transferEntitlementData = action?.payload ? action.payload : [];
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          update: true,
        };
      })
      .addCase(transferEntitlement.rejected, handleRejection)

      .addCase(entitlementTransferData.pending, (state) => {
        state.entitlementTransferDataData = [];
        state.entitlementTransferDataDataTotalCount = 0;
        state.entitlementTransferDataFound = false;
        state.entitlementTransferLoading = true;
      })
      .addCase(entitlementTransferData.fulfilled, (state, action) => {
        state.entitlementTransferDataData =
          action?.payload?.entitlementToTransfer;
        state.entitlementTransferDataDataTotalCount =
          action?.payload?.totalRecords;
        state.entitlementTransferDataFound = true;
        state.entitlementTransferLoading = false;
        state.entitlementTrasferGridDisplay = true;
      })
      .addCase(entitlementTransferData.rejected, (state) => {
        state.entitlementTransferDataData = [];
        state.entitlementTransferDataDataTotalCount = 0;
        state.entitlementTransferDataFound = false;
        state.entitlementTransferLoading = false;
        state.entitlementTrasferGridDisplay = true;
      })

      .addCase(entitlementWarrantyData.pending, (state) => {
        state.isLoadingWarrantyData = true;
        state.entitlementWarrantyHistoryData = [];
        state.entitlementWarrantyHistoryDataTotalCount = 0;
        state.isEntitlementWarrantyHistoryDataFound = false;
      })
      .addCase(entitlementWarrantyData.fulfilled, (state, action) => {
        state.entitlementWarrantyHistoryData = action?.payload
          ?.warrantyHistoryData
          ? action?.payload?.warrantyHistoryData
          : [];
        state.entitlementWarrantyHistoryDataTotalCount = action?.payload
          ?.totalRecords
          ? action?.payload?.totalRecords
          : 0;
        state.isEntitlementWarrantyHistoryDataFound = true;
        state.isLoadingWarrantyData = false;
      })
      .addCase(entitlementWarrantyData.rejected, (state) => {
        state.isLoadingWarrantyData = false;
        state.entitlementWarrantyHistoryData = [];
        state.entitlementWarrantyHistoryDataTotalCount = 0;
        state.isEntitlementWarrantyHistoryDataFound = false;
      })

      .addCase(entitlementSerialNumberHistoryData.pending, (state) => {
        state.isLoadingSerialNumberData = true;
        state.entitlementSerialNumberHistoryData = [];
        state.isEntitlementSerialNumberHistoryDataFound = false;
        state.entitlementSerialNumberHistoryTotalCount = 0;
      })
      .addCase(
        entitlementSerialNumberHistoryData.fulfilled,
        (state, action) => {
          state.entitlementSerialNumberHistoryData = action?.payload
            ?.warrantySerialHistoryData
            ? action?.payload?.warrantySerialHistoryData
            : [];
          state.entitlementSerialNumberHistoryTotalCount = action?.payload
            .totalRecords
            ? action?.payload?.totalRecords
            : 0;
          state.isEntitlementSerialNumberHistoryDataFound = true;
          state.isLoadingSerialNumberData = false;
        }
      )
      .addCase(entitlementSerialNumberHistoryData.rejected, (state) => {
        state.isLoadingSerialNumberData = false;
        state.entitlementSerialNumberHistoryData = [];
        state.isEntitlementSerialNumberHistoryDataFound = false;
        state.entitlementSerialNumberHistoryTotalCount = 0;
      })

      .addCase(specificWarrantyHistoryDetailsData.pending, handlePending)
      .addCase(
        specificWarrantyHistoryDetailsData.fulfilled,
        (state, action) => {
          state.getEntitlementSpecificWarrantyHistoryDetailsData =
            action?.payload ? action?.payload : [];
          state.isEntitlementSpecificWarrantyHistoryDetailsDataFound = true;
        }
      )
      .addCase(specificWarrantyHistoryDetailsData.rejected, handleRejection)

      .addCase(checkWarrantyHistoryUpsert.pending, (state) => {
        state.isCheckedWarrantyUpsert = null;
        state.popupLoadingWait = true;
      })
      .addCase(checkWarrantyHistoryUpsert.fulfilled, (state, action) => {
        state.isCheckedWarrantyUpsert = action?.payload
          ? action?.payload
          : false;
        state.popupLoadingWait = false;
      })
      .addCase(checkWarrantyHistoryUpsert.rejected, (state) => {
        state.isCheckedWarrantyUpsert = false;
        state.popupLoadingWait = false;
      })

      .addCase(validateWarrantyHistoryStartDate.pending, (state) => {
        state.newWarrantyLoader = true;
        state.isStartDateValidated = null;
        state.startDateValidatedErrorMessage = '';
      })
      .addCase(validateWarrantyHistoryStartDate.fulfilled, (state, action) => {
        state.newWarrantyLoader = false;
        if (action?.payload === 'True')
          state.isStartDateValidated = action?.payload;
        else {
          state.isStartDateValidated = false;
          state.startDateValidatedErrorMessage = action?.payload
            ? action?.payload
            : '';
        }
      })
      .addCase(validateWarrantyHistoryStartDate.rejected, (state) => {
        state.isStartDateValidated = false;
      })

      .addCase(createNewEntitlementWarranty.pending, (state) => {
        state.newWarrantyLoader = true;
      })
      .addCase(createNewEntitlementWarranty.fulfilled, (state) => {
        state.newWarrantyLoader = false;
        state.apiWarrentySuccessResponse = {
          ...initialState.apiWarrentySuccessResponse,
          create: true,
        };
      })
      .addCase(createNewEntitlementWarranty.rejected, handleRejection)

      .addCase(updateNewEntitlementWarranty.pending, (state) => {
        state.editWarrantyLoader = true;
      })
      .addCase(updateNewEntitlementWarranty.fulfilled, (state) => {
        state.editWarrantyLoader = false;
        state.apiWarrentySuccessResponse = {
          ...initialState.apiWarrentySuccessResponse,
          update: true,
        };
      })
      .addCase(updateNewEntitlementWarranty.rejected, handleRejection)

      .addCase(createUpdateNewEntitlementHistory.pending, (state) => {
        state.apiHistoryAddUpdateLoader = true;
        state.apiHistorySuccessResponse = {
          ...initialState.apiHistorySuccessResponse,
          update: false,
          create: false,
        };
      })
      .addCase(createUpdateNewEntitlementHistory.fulfilled, (state) => {
        state.apiHistoryAddUpdateLoader = false;
        state.apiHistorySuccessResponse = {
          ...initialState.apiHistorySuccessResponse,
          create: false,
          update: true,
        };
      })
      .addCase(createUpdateNewEntitlementHistory.rejected, (state) => {
        state.apiHistoryAddUpdateLoader = false;
        state.apiHistorySuccessResponse = {
          ...initialState.apiHistorySuccessResponse,
          update: false,
          create: false,
        };
      })

      .addCase(saveAndCloseEntitlementTransfer.pending, (state) => {
        state.apiHistoryTransferLoader = true;
        state.trasferResult = [];
        state.apiHistoryTransferSuccessResponse = {
          ...initialState.apiHistoryTransferSuccessResponse,
          update: false,
          create: false,
        };
      })
      .addCase(saveAndCloseEntitlementTransfer.fulfilled, (state, action) => {
        state.apiHistoryTransferLoader = false;
        state.trasferResult = action?.payload ? action?.payload : [];
        state.isSiteActivityFailed = false;
        state.apiHistoryTransferSuccessResponse = {
          ...initialState.apiHistoryTransferSuccessResponse,
          create: true,
          update: false,
        };

        if (action?.payload?.siteActivityId !== 0) {
          state.entitlementTrasferGridDisplay = false;
        }
      })
      .addCase(saveAndCloseEntitlementTransfer.rejected, (state, action) => {
        state.apiHistoryTransferLoader = false;
        state.trasferResult = [];
        state.isSiteActivityFailed = true;
        state.apiHistoryTransferSuccessResponse = {
          ...initialState.apiHistoryTransferSuccessResponse,
          update: false,
          create: false,
        };

        if (action?.payload?.siteActivityId !== 0) {
          state.entitlementTrasferGridDisplay = false;
        }
      })

      //
      .addCase(saveAndCloseEntitlementSite.pending, (state) => {
        state.historyTransferSiteLoader = true;
        state.historyTransferSiteData = [];
      })
      .addCase(saveAndCloseEntitlementSite.fulfilled, (state, action) => {
        state.historyTransferSiteLoader = action?.payload
          ? action?.payload
          : [];
        state.historyTransferSiteData = [];
      })
      .addCase(saveAndCloseEntitlementSite.rejected, (state) => {
        state.historyTransferSiteLoader = false;
        state.historyTransferSiteData = [];
      })

      //
      .addCase(saveAndCloseEntitlementSiteActivity.pending, (state) => {
        state.historyTransferSiteActivityLoader = true;
        state.historyTransferSiteActivityData = [];
      })
      .addCase(
        saveAndCloseEntitlementSiteActivity.fulfilled,
        (state, action) => {
          state.historyTransferSiteActivityLoader = action?.payload
            ? action?.payload
            : [];
          state.historyTransferSiteActivityData = [];
        }
      )
      .addCase(saveAndCloseEntitlementSiteActivity.rejected, (state) => {
        state.historyTransferSiteActivityLoader = false;
        state.historyTransferSiteActivityData = [];
      });
  },
});

export const {
  setDate,
  setErrorMessages,
  editModalOpen,
  editModalClose,
  setCurrencyData,
  setServiceLevelData,
  setAnnualFeeData,
  setStatusData,
  setCommentData,
  addModalClose,
  addModalOpen,
  addNewNote,
  setERPProductDisplay,
  isWarrantyAddModalOpen,
  isWarrantyEditModalOpen,
  setErrorMessagePopup,
  errorMessageStateToInitialState,
  warrantyHistorySpecificData,
  addWarrantyButtonClickState,
  addWarrantyStartDate,
  addWarrantyDuration,
  addWarrantyFeeDefferal,
  warrantyAddComment,
  resetingAddWarrantyForm,
  settingErrorMessage,
  settingIsEditMode,
  settingHistoryAddEdit,
  updateErrorMessagePopUpState,
  resettingTransferDataFound,
  settingTransferGridDataRow,
  settingCheckedWarrantyUpsert,
  settingWarrantySpecificDataToNull,
  settingRedirectionSiteActivityFlag,
  resetapiSuccessAction,
  handleSiteForTransfer,
  handleSiteForShowData,
  handleResetApiCall,
  handleNotRefreshEntOnTransfer,
  resetIsSiteActivityFailed,
} = entitlementHistorySlice.actions;
export default entitlementHistorySlice.reducer;
